'use client';

import { AdSlot } from '@/app_components/AdSlot/Adslot';
import { useAdContext } from '@/app_lib/providers/AdProvider';
import { ContentPlacement } from '@/app_lib/types/analytics';
import { cn } from '@/app_lib/utils/utils';

interface RightRailArticleAdProps {
  sticky?: boolean;
  marginTop?: number;
  index?: number;
}

export const RightRailArticleAd = ({ sticky = false, marginTop = 0, index }: RightRailArticleAdProps) => {
  const { pageAdConfig } = useAdContext();
  return (
    <div
      className={cn(
        sticky && 'sticky top-[calc(var(--leaderboard-height)+var(--header-height)+var(--disclaimer-height))]',
        'w-[(--max-rail-article-width)] flex justify-center', //Max width for right rail article ad, centered horizontally
      )}
      data-cy={ContentPlacement.RightRailArticleSticky}
      style={{ marginTop }}
    >
      {pageAdConfig && (
        <AdSlot
          index={index}
          placementName='RightRail_Article'
          sticky={sticky}
        />
      )}
    </div>
  );
};
